'use strict';
import ajax from '../../common/ajax';

export default class AccordionModel {
    constructor(letter) {
        this.currPage = 1;
        this.pattern = letter;
        this.finished = false;
        this.alreadyCalledSlideIndex = {};
        const mcpRegex = /most-creative-people|mcp/;
        this.windowLocationPath = window.location.pathname;
        this.isMCP = mcpRegex.test(this.windowLocationPath);
    }

    get(slideIndex) {
        const promise = ajax(this.buildURI(), {
            method: 'GET',
            timeout: 3000
        });
        this.currPage += 1;
        if (slideIndex) {
            this.alreadyCalledSlideIndex[slideIndex] = true;
        }
        return promise;
        // }
    }

    buildURI() {
        let base = `https://api.fastcompany.com/v1/packages/companies/search/pattern?page=${this.currPage}&rows_per_page=60&pattern=${this.pattern}`;

        return base;
    }

    setFinishedState(reason) {
        this.finished = true;
    }
}
